import { Popover } from 'antd'
import { useState, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { getConclusionHrefByMeeting, getPreparationPdfHrefByMeeting } from '../../../modules/meeting/util/hrefUtils'
import { Meeting, MeetingPdfStatus } from '../../../types'
import PerButtonCircle from '../ButtonCircle'
import { PerSpacerProps } from '../Spacer'
import PerText from '../Text'

export interface PdfDownloadPopoverProps extends PerSpacerProps {
  meeting: Meeting
  preparationVisible: boolean
}

export const PdfDownloadPopover: FC<PdfDownloadPopoverProps> = ({ meeting, preparationVisible, ...spacerProps }) => {
  const [popoverOpen, setPopoverOpen] = useState(false)
  const [t] = useTranslation()
  return (
    <>
      <Popover
        content={
          <>
            {preparationVisible && meeting.employeePrepared && meeting.preparationPdfStatus === MeetingPdfStatus.FinishedSuccess && (
              <PerText fontSize="m" mb="xs">
                <a onClick={() => setPopoverOpen(false)} href={getPreparationPdfHrefByMeeting(meeting)}>
                  {t('appraisalMeeting.pdfDownloadPopover.preparation')}
                </a>
              </PerText>
            )}
            <PerText fontSize="m">
              <a onClick={() => setPopoverOpen(false)} href={getConclusionHrefByMeeting(meeting)}>
                {t('appraisalMeeting.pdfDownloadPopover.conclusion')}
              </a>
            </PerText>
          </>
        }
        title={<PerText color="secondary">{t('appraisalMeeting.pdfDownloadPopover.documents')}</PerText>}
        trigger="click"
        visible={popoverOpen}
        onVisibleChange={setPopoverOpen}
        destroyTooltipOnHide
      >
        <PerButtonCircle
          icon="file_fill"
          color="primary"
          variant="pastel"
          tooltip={t('tooltip.view')}
          onClick={() => setPopoverOpen(true)}
          {...spacerProps}
        />
      </Popover>
    </>
  )
}
